import { createStyles, withStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import { makeStyles } from '@material-ui/core';

export const useStyles = makeStyles(() =>
  createStyles({
    message: {
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      position: 'relative',
      top: '140px',
      left: '45px',
      justifyItems: 'center'
    },
    text: {
      position: 'relative',
      fontFamily: 'Roboto',
      fontStyle: 'normal',
      fontWeight: 'bold',
      fontSize: 18,
      lineHeight: '21px',
      color: '#2C2D3E',
      height: '42px',
      textAlign: 'center'
    },
    successCheck: {
      width: '49px',
      position: 'relative',
      top: '63px',
      left: '209px',
    },
    unsuccessCheck: {
      width: '49px',
      position: 'relative',
      top: '35px',
      left: '209px',
    },
    textUnsuccessPrimary: {
      position: 'relative',
      width: '268px',
      fontFamily: 'Roboto',
      fontStyle: 'normal',
      fontWeight: 'bold',
      fontSize: 18,
      left: '55px',
      lineHeight: '21px',
      color: '#2C2D3E',
      height: '42px',
      top: '115px',
      textAlign: 'center',
    },
    textUnsuccessSecondary: {
      position: 'relative',
      fontFamily: 'Roboto',
      fontStyle: 'normal',
      fontWeight: 'normal',
      fontSize: 16,
      left: '55px',
      lineHeight: '21px',
      color: '#2C2D3E',
      height: '42px',
      top: '130px',
      textAlign: 'center',
    },
    backToList: {
      position: 'relative',
      left: '130px',
      top: '141px',
    },

    backToListSecondary: {
      position: 'relative',
      left: '118px',
      top: '155px',
    },
  }),
);

export const styles = () =>
  createStyles({
    root: {
      height: '380px',
      width: '466px',
      margin: 0,
      padding: 0,
    },
  });

export const BackToListButton = withStyles(() => ({
  root: {
    width: '219px',
    height: '45px',
    border: 'solid 1px #3C419A',
    color: '#FFFFFF',
    backgroundColor: '#3C419A',
    boxShadow: 'none',
    '&:hover': {
      backgroundColor: '#3C419A',
    },
  },
}))(Button);
